var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"qa-enabled-indicator"},[_vm._v("QA")])
}
var staticRenderFns = []

export { render, staticRenderFns }